// extracted by mini-css-extract-plugin
export default {"content":"files-list_content__fJIyT"};